import { useEffect, useRef, useMemo } from 'react';
import { debounce } from 'lodash';
import type { UseFormWatch } from 'react-hook-form';

export const useAutoSave = (onSubmit: () => void, watch: UseFormWatch<any>, delayMs = 300) => {
  const latestOnSubmit = useRef(onSubmit);
  latestOnSubmit.current = onSubmit;

  const debouncedSubmit = useMemo(
    () =>
      debounce(() => {
        latestOnSubmit.current();
      }, delayMs),
    [delayMs],
  );

  useEffect(() => {
    return () => {
      debouncedSubmit.cancel();
    };
  }, [debouncedSubmit]);

  useEffect(() => {
    const subscription = watch((_, { type }) => {
      if (type === 'change') {
        debouncedSubmit();
      }
    });
    return () => {
      subscription.unsubscribe();
      debouncedSubmit.cancel();
    };
  }, [watch, debouncedSubmit]);
};
